<style scoped>
.color-panel-item {
  padding-left: 5px;
  padding-right: 5px;
}
.color-panel-label {
  text-align: center;
}
</style>

<template>

<div class="component-wrapper">
  <mu-chip
    @click.stop.prevent="canEdit ? flagDialogEdit = true : ''"
    :style="styleTag"
    :delete="canEdit"
    @delete="canEdit ? flagDialogDelete = true : ''"
    >
    <span>{{tag.name}}</span>
  </mu-chip>
  <mu-dialog :title="$t('button.edit') + $t('space') + $t('tag.title')" max-width="100%" scrollable :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogEdit">
    <mu-form :model="form" label-width="500">
      <mu-form-item prop="input" :label="$t('tag.title')">
        <mu-text-field v-model="modelName"></mu-text-field>
      </mu-form-item>
    </mu-form>
    <div class="display-flex">
      <div class="color-panel-item">
        <div class="color-panel-label">{{$t('tag.textColor')}}</div>
        <color-picker :value="modelColor" @input="onUpdateColor" />
      </div>
      <div class="color-panel-item flex-item">
        <div class="color-panel-label">{{$t('button.preview')}}</div>
        <div>
          <mu-chip :style="styleTag">
            <span>{{computedName}}</span>
          </mu-chip>
        </div>
      </div>
      <div class="color-panel-item">
        <div class="color-panel-label">{{$t('tag.bgColor')}}</div>
        <color-picker :value="modelBgColor" @input="onUpdateBgColor" />
      </div>
    </div>
    <mu-button slot="actions" flat color="primary" @click="onActionCancel"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
    <mu-button slot="actions" flat color="primary" @click="onActionEdit" :disabled="isNameEmpty"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
  </mu-dialog>
  <mu-dialog :title="$t('button.delete') + $t('space') + $t('tag.title')" max-width="100%" scrollable :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogDelete">
    {{stringDelete}}
    <mu-button slot="actions" flat color="primary" @click="onCancelDelete"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
    <mu-button slot="actions" flat color="primary" @click="onActionDelete"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
  </mu-dialog>
</div>

</template>

<script>

// Library
import { Compact } from 'vue-color'

// Library
import axios from "axios";

export default {
  name: 'TagItem',
  components: {
    'color-picker': Compact
  },
  props: {
    tag: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // Flag
      flagDialogEdit: false, // Boolean variable for status of edit dialog
      flagDialogDelete: false, // Boolean variable for status of delete dialog

      // Model
      modelName: this.tag.name, // Bind with name input
      modelColor: this.tag.color,
      modelBgColor: this.tag.backgroundColor,
      form: {},
    }
  },
  computed: {
    // Flag
    isNameEmpty() {
      if (this.modelName === "") {
        return true;
      } else {
        return false;
      }
    },

    // String
    computedName() {
      if(this.isNameEmpty) {
        return this.$t('tag.title');
      } else {
        return this.modelName;
      }
    },

    // String
    stringDelete() {
      return this.$t('prompt.deleteMsg', { name: this.modelName });
    },

    // Constant
    constTrue() {
      return true;
    },
    constFalse() {
      return false;
    },

    // Style
    styleTag() {
      return {
        color: this.stringColor,
        backgroundColor: this.stringBgColor
      };
    },
    stringColor() {
      if (typeof this.modelColor != 'undefined')
        return "rgba(" + this.modelColor.r + ", " + this.modelColor.g + ", " + this.modelColor.b + ", " + this.modelColor.a + ")";
      else
        return "rgba(255,255,255,1)";
    },
    stringBgColor() {
      if (typeof this.modelBgColor != 'undefined')
        return "rgba(" + this.modelBgColor.r + ", " + this.modelBgColor.g + ", " + this.modelBgColor.b + ", " + this.modelBgColor.a + ")";
      else
        return "rgba(0,0,0,0.5)";
    },
  },
  methods: {
    // Event
    onEditTag() {
      this.flagDialogEdit = true;
    },
    onActionEdit() {
      this.flagDialogEdit = false;
      axios.put(this.$store.getters.urlApi + "tag/" + this.tag._id, {
        'name': this.modelName,
        'color': this.modelColor,
        'backgroundColor': this.modelBgColor
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(() => {
        this.$store.commit("triggerRefresh");
        this.$toast.success(this.$t('toast.edit'));
      });
    },
    onClickDelete() {
      this.flagDialogDelete = true;
      this.flagDialogEdit = false;
    },
    onCancelDelete() {
      this.flagDialogDelete = false;
    },
    onActionDelete() {
      this.flagDialogDelete = false;
      axios.delete(this.$store.getters.urlApi + "tag/" + this.tag._id, {
        headers: {
          token: this.$store.state.auth.token
        },
        params: {
          'ids': this.attachmentIds
        }
        }
      ).then(() => {
        this.$store.commit("triggerRefresh");
        this.$toast.success(this.$t('toast.delete'));
      });
    },
    onActionCancel() {
      this.flagDialogEdit = false;
      this.modelName = this.tag.name;
    },
    onUpdateColor(color) {
      this.modelColor = color.rgba;
    },
    onUpdateBgColor(color) {
      this.modelBgColor = color.rgba;
    },
  },

}
</script>
